import React from 'react';
import { Button } from '../ui/Button';
import { SelectField, TextAreaField, TextField } from '../ui/Field';
import { FormCard, FormError, FormFooterNote, FormSuccess } from './FormShell';
import { useLeadSubmit } from '../../hooks/useLeadSubmit';
export function FinanciacionForm({
  vehiculoInicial = ''
}: {
  vehiculoInicial?: string;
}) {
  const {
    status,
    sending,
    submitted,
    reference,
    submitForm,
    retry
  } = useLeadSubmit('financiacion', 'Financiación');
  if (submitted) {
    return <FormSuccess message="Gracias por tu consulta. Un asesor de VCARS se comunicará con vos a la brevedad." reference={reference} data-id="element-75" data-mp="lt92p3msue8r" />;
  }
  return <FormCard title="Consultá financiación" lead="Contanos qué buscás y armamos una propuesta de cuotas según tu perfil. Consulta sin compromiso." data-id="element-76" data-mp="vqn7u739vglr">
      {status === 'error' ? <FormError onRetry={retry} data-id="element-77" data-mp="2b98iv4ou53xw" /> : null}
      <form className="grid gap-4 sm:grid-cols-2" onSubmit={submitForm} data-id="element-78" data-mp="274qz35ih6qn4">
        <TextField id="nombre" label="Nombre y apellido" required autoComplete="name" data-id="element-79" data-mp="7pti2d0n1aou" />
        <TextField id="telefono" label="Teléfono" type="tel" required autoComplete="tel" data-id="element-80" data-mp="coml1biatjar" />
        <TextField id="email" label="Email" type="email" required autoComplete="email" data-id="element-81" data-mp="cqh9v0woxvk4" />
        <TextField id="vehiculo" label="Vehículo de interés" defaultValue={vehiculoInicial} placeholder="Ej: Toyota Corolla Cross 0KM" data-id="element-82" data-mp="go54s3ydvoc0" />
        <TextField id="presupuesto" label="Presupuesto estimado" placeholder="Ej: USD 25.000 o cuota de $450.000" data-id="element-83" data-mp="3l6aqrguxp91p" />
        <SelectField id="permutaParteDePago" label="¿Tenés vehículo para entregar en parte de pago?" options={['Sí', 'No', 'A definir']} required data-id="element-84" data-mp="3u4mcp5kuvint" />
        <TextAreaField id="mensaje" label="Mensaje adicional" className="sm:col-span-2" placeholder="Contanos plazos, uso previsto o cualquier detalle que nos ayude." data-id="element-85" data-mp="31h0c866xcu56" />
        <div className="sm:col-span-2" data-id="element-86" data-mp="dk1m22yqfi3t">
          <Button type="submit" size="lg" className="w-full sm:w-auto" disabled={sending} data-id="element-87" data-mp="diytzrpob9mb">
            {sending ? 'Enviando consulta…' : 'Consultar financiación'}
          </Button>
          <FormFooterNote data-id="element-88" data-mp="mcvhpayhku3u">
            Te acompañamos durante toda la operación: evaluación rápida, sin compromiso y
            con asesoramiento personalizado.
          </FormFooterNote>
        </div>
      </form>
    </FormCard>;
}